import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	assets: null,
	total: 0,
	asset: null,
	error: "",
	loading: false,
};

// ADD_Assets
export const addAssets = createAsyncThunk(
	"asset/addAssets",
	async (values) => {
		try {
			// console.log("slice values", values)
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
					// "Content-Type": "multipart/form-data",
				},
				url: `assets/`,
				data: {
					...values,
				},
			},
			);
			// console.log("data", data)
			toast.success("asset Type Created");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in creating asset, try again!");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// ADD_AssetsType
export const addAssetsType = createAsyncThunk(
	"asset/addAssetsType",
	async (values) => {
		try {
			// console.log("slice values", values)
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
					// "Content-Type": "multipart/form-data",
				},
				url: `assets/assetType`,
				data: {
					...values,
				},
			},
			);
			// console.log("data", data)
			toast.success("asset Created");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in creating asset, try again!");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const assignAsset = createAsyncThunk(
	"asset/assignAsset",
	async (values) => {
		try {
			// console.log("slice values", values)
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
					// "Content-Type": "multipart/form-data",
				},
				url: `assets/assignAsset`,
				data: {
					...values,
				},
			},
			);
			// console.log("data", data)
			toast.success("Asset assigned successfully");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in Assign asset, try again!");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);



export const getAssetTypes = createAsyncThunk(
	"asset/getAssetTypes",
	async () => {
		try {
			const { data } = await axios.get(`assets/getAssetTypes`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

export const getAssets = createAsyncThunk(
	"asset/getAssets",
	async () => {
		try {
			const { data } = await axios.get(`assets/getAssets`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

export const returnAsset = createAsyncThunk(
	"asset/returnAsset",
	async ({ assetId, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `assets/returnAsset/${assetId}`,
				data: {
					...values,
				},
			});
			toast.success("Return Assets Succesfully");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in Return Assets try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const getAssignmentsByUserId = createAsyncThunk(
	"assets/getAssignmentsByUserId",
	async (id) => {
		try {
			const { data } = await axios.get(`assets/getAssignmentsByUserId/${id}`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);


const AssetsSlice = createSlice({
	name: "assetsForm",
	initialState,
	reducers: {
		clearAssetsForm: (state) => {
			state.asset = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for addAssets ======

		builder.addCase(addAssets.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addAssets.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addAssets.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for getAssetTypes ======

		builder.addCase(getAssetTypes.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAssetTypes.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAssetTypes.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		
		// 2) ====== builders for getAssets ======

		builder.addCase(getAssets.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAssets.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAssets.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for addAssetsType ======

		builder.addCase(addAssetsType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addAssetsType.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addAssetsType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for assignAsset ======

		builder.addCase(assignAsset.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(assignAsset.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(assignAsset.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for returnAsset ======

		builder.addCase(returnAsset.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(returnAsset.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(returnAsset.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 6) ====== builders for getAssignmentsByUserId ======

		builder.addCase(getAssignmentsByUserId.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAssignmentsByUserId.fulfilled, (state, action) => {
			// console.log(action.payload);
			state.loading = false;
			state.assetsByUser = action.payload;
		});

		builder.addCase(getAssignmentsByUserId.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

	},
});

export default AssetsSlice.reducer;
export const { clearAssetsForm } = AssetsSlice.actions;
